import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import QrReader from 'react-qr-reader';
import { Button, Header, Message, Modal } from 'semantic-ui-react';
import { Activity } from '../../../models/activity';
import { useStore } from '../../../stores/store';
import { userLanguage } from '../../userLanguageSchema/userLanguage';

interface Props {
  activityid: string;
  qrcodeValue: string | undefined;
}

function QrCodeScannerModal({ activityid, qrcodeValue }: Props) {
  const { dashboardStore, activityStore, commonStore } = useStore();
  const { activityRegistryQrcode } = activityStore;
  const [, setOpen] = useState(false);
  const [result, setResult] = useState<any>('');
  const [errorState, setErrorState] = useState('');
  const [camError, setCamError] = useState<boolean>(false);
  const handleScan = (data: any) => {
    if (data !== null) {
      if (data !== activityid || data !== qrcodeValue) {
        const existData: Activity | undefined =
          activityRegistryQrcode.get(data);

        if (!existData) {
          setErrorState('');
          setResult(data);
        }
        if (existData) setErrorState('Data Already Exist');
      } else {
        setErrorState('Same Data Detected');
      }
    }
  };
  const handleError = (err: any) => {
    console.error(err);
    setCamError(true);
  };
  const handleSave = () => {
    dashboardStore.setQrCodeValue(result);
    dashboardStore.setOpenQrCodeScanner(false);
  };
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={dashboardStore.dashboard.openQrCodeScanner}
    >
      <Modal.Header
      //Scan QR Code
      >
        {
          (
            userLanguage[0].Level3InventoryRecievingTagScanQrModal
              ?.IRTSQRL01 as any
          )?.[`${commonStore.language.key}`]
        }{' '}
      </Modal.Header>
      <Modal.Content>
        {result.length !== 0 ? (
          <Header>{result}</Header>
        ) : (
          <>
            {camError === false ? (
              <QrReader
                delay={300}
                onError={handleError}
                onScan={handleScan}
                style={{ width: '100%' }}
                facingMode="environment"
              />
            ) : (
              <h1
                style={{
                  color: 'black',
                  textAlign: 'center',
                  alignItems: 'center',
                }}
                //Camera not accessible
              >
                {
                  (
                    userLanguage[0].Level3InventoryRecievingTagScanQrModal
                      ?.IRTSQRL02 as any
                  )?.[`${commonStore.language.key}`]
                }
              </h1>
            )}
            {errorState.length > 0 && (
              <Message negative>
                <Message.Header>{errorState}</Message.Header>
              </Message>
            )}
          </>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => dashboardStore.setOpenQrCodeScanner(false)}
          //Cancel
        >
          {
            (
              userLanguage[0].Level3InventoryRecievingTagScanQrModal
                ?.IRTSQRB01 as any
            )?.[`${commonStore.language.key}`]
          }
        </Button>
        <Button
          //content="Save"
          content={
            (
              userLanguage[0].Level3InventoryRecievingTagScanQrModal
                ?.IRTSQRB02 as any
            )?.[`${commonStore.language.key}`]
          }
          labelPosition="right"
          icon="checkmark"
          onClick={handleSave}
          positive
          disabled={errorState.length > 0 ? true : false}
        />
      </Modal.Actions>
    </Modal>
  );
}

export default observer(QrCodeScannerModal);
